import React from 'react'
import { Row, Col, Button, Table, Media } from 'reactstrap'
import { Link } from 'react-router-dom'
import Loader from "../../../components/Loader";
import logo from "../../../assets/images/gov-logo.png";
import axios from "../../../services/axios";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import moment from 'moment';
import { ArrowLeft } from "@material-ui/icons"
import {
    useParams
} from "react-router-dom";

function ExecutiveSummaryReport(props) {

    const [loading, setloading] = React.useState(true)
    const [visit, setVisit] = React.useState({})
    const [followupVisit, setFollowupVisit] = React.useState({})
    const [nationalStandards, setNationalStandards] = React.useState([]) // Initialize as array
    const [firstInspector, setFirstInspector] = React.useState({})
    const [secondInspector, setSecondInspector] = React.useState({})
    const [thirdInspector, setThirdInspector] = React.useState({})
    const [fourthInspector, setFourthInspector] = React.useState({})
    const [minorRecommendations, setMinorRecommendations] = React.useState([]) // Initialize as array

    const { id, followupid } = useParams()

    const getData = async () => {
        try {
            // Use Promise.all to wait for all requests to complete
            const [
                visitRes,
                followupRes,
                standardsRes,
                firstInspectorRes,
                secondInspectorRes,
                thirdInspectorRes,
                fourthInspectorRes,
                recommendationsRes
            ] = await Promise.all([
                axios.get(`inspection_visits/${id}`),
                axios.get(`inspection_visits/${followupid}`),
                axios.get(`/national_standards`),
                axios.get(`/inspection_report/first_inspector/${id}`),
                axios.get(`/inspection_report/second_inspector/${id}`),
                axios.get(`/inspection_report/third_inspector/${id}`),
                axios.get(`/inspection_report/fourth_inspector/${id}`),
                axios.get(`recommendations/minor/${id}`)
            ]);

            // Safely extract data from responses
            setVisit(visitRes.data?.[0] || {});
            setFollowupVisit(followupRes.data?.[0] || {});
            
            // Handle national standards - could be array or object with data property
            let standardsData = [];
            if (standardsRes.data) {
                if (Array.isArray(standardsRes.data)) {
                    standardsData = standardsRes.data;
                } else if (standardsRes.data.data && Array.isArray(standardsRes.data.data)) {
                    standardsData = standardsRes.data.data;
                }
            }
            setNationalStandards(standardsData);
            
            // Handle inspectors
            setFirstInspector(firstInspectorRes.data?.[0] || {});
            setSecondInspector(secondInspectorRes.data?.[0] || {});
            setThirdInspector(thirdInspectorRes.data?.[0] || {});
            setFourthInspector(fourthInspectorRes.data?.[0] || {});
            
            // Handle recommendations - this was causing the error
            let recommendationsData = [];
            if (recommendationsRes.data) {
                if (Array.isArray(recommendationsRes.data)) {
                    recommendationsData = recommendationsRes.data;
                } else if (recommendationsRes.data.data && Array.isArray(recommendationsRes.data.data)) {
                    recommendationsData = recommendationsRes.data.data;
                }
            }
            setMinorRecommendations(recommendationsData);
            
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            setloading(false);
        }
    }

    React.useEffect(() => {
        getData();
    }, [])

    const generateWord = () => {
        var filename = 'FOLLOW_UP_INSPECTION_REPORT'
        var element = 'report'
        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
        var postHtml = "</body></html>";
        var html = preHtml + document.getElementById(element).innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        filename = filename ? filename + '.doc' : 'document.doc';

        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            downloadLink.href = url;
            downloadLink.download = filename;
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    // Helper function to safely get inspector names
    const getInspectorName = (inspector) => {
        return inspector?.full_name || 'N/A';
    }

    // Helper function to safely get national standard name
    const getNationalStandardName = (nesId) => {
        if (!Array.isArray(nationalStandards)) return 'N/A';
        const standard = nationalStandards.find(ns => ns.nes_id == nesId);
        return standard?.nes_name || 'N/A';
    }

    // Helper function to map need_extra_followups to achievement status
    const getAchievementStatus = (value) => {
        if (value === 'No') return 'Achieved';
        if (value === 'Yes') return 'Not Achieved';
        return value || '';
    }

    return (
        <div>
            <React.Fragment>
                <div className="container">
                    <Row className="position-center">
                        {loading && <Loader />}
                    </Row>

                    <Row className="align-items-center">
                        <Col sm={6}>
                            <div className="page-title-box">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Inspection Followup Report</li>
                                </ol>
                            </div>
                        </Col>
                        <Col sm="6">
                            <div className="float-right d-none d-md-block">
                                <Link className="btn btn-primary" to={`/followup_visits/`} >
                                    <ArrowLeft /> Back
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="container">
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="card">
                                <div className="card-body">
                                    <hr />
                                    <Row>
                                        <Col style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                            <Button onClick={generateWord} className="btn btn-success pull-right">
                                                <FileDownloadIcon />
                                            </Button>
                                        </Col>
                                    </Row>
                                    <hr />
                                    
                                    <Table className='table table-responsive' id='report' bordered responsive>
                                        <thead>
                                            <tr>
                                                <th colSpan="3" className="text-center">
                                                    <img src={logo} alt="Government Logo" height="80" />
                                                </th>
                                            </tr>
                                            <tr>
                                                <th colSpan='3' className="text-center">
                                                    <h2>FOLLOW UP INSPECTION REPORT</h2>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th width="30%">HEAD TEACHER</th>
                                                <th width="5%">:</th>
                                                <td>{visit?.head_teacher || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <th>ESTABLISHMENT YEAR</th>
                                                <th>:</th>
                                                <td>{visit?.establishment_year || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <th>POSTAL ADDRESS</th>
                                                <th>:</th>
                                                <td>{visit?.school_address || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <th>FULL INSPECTION DATE</th>
                                                <th>:</th>
                                                <td>{visit?.present_visitation_date ? moment(visit.present_visitation_date).format("LL") : 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <th>FOLLOW UP INSPECTION DATE</th>
                                                <th>:</th>
                                                <td>{followupVisit?.present_visitation_date ? moment(followupVisit.present_visitation_date).format("LL") : 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <th>LEAD INSPECTOR</th>
                                                <th>:</th>
                                                <td>{getInspectorName(firstInspector)}</td>
                                            </tr>
                                            <tr>
                                                <th>INSPECTION TEAM</th>
                                                <th>:</th>
                                                <td>
                                                    1. {getInspectorName(firstInspector)}<br />
                                                    2. {getInspectorName(secondInspector)}<br />
                                                    3. {getInspectorName(thirdInspector) !== 'N/A' ? getInspectorName(thirdInspector) : 'None'}<br />
                                                    4. {getInspectorName(fourthInspector) !== 'N/A' ? getInspectorName(fourthInspector) : 'None'}
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colSpan="3">
                                                    <hr />
                                                    <h3><strong>1.0. BACKGROUND TO THE SCHOOL</strong></h3>
                                                    <p>
                                                        The school was established in {visit?.establishment_year || 'N/A'} and has an enrolment of ... students (... boys and ... girls). 
                                                        The school has ... teachers of which ... are males and ... are females; ... are qualified and ... unqualified. 
                                                        On the day of inspection, ... teachers were present, and ... students attended school. 
                                                        The community around the school earns its living mainly through small scale businesses as most people travel to South Africa 
                                                        in search for jobs and so they bring back commodities for sale. It is a single streamed school which has 6 classrooms of 
                                                        which one is used as a staffroom and has a temporary administration block. 
                                                        The Directorate of Quality Assurance Services (DQAS) conducted a follow-up visit to the school on{' '}
                                                        {followupVisit?.present_visitation_date ? moment(followupVisit.present_visitation_date).format("LL") : 'N/A'}. 
                                                        This was a follow up to the full inspection that was carried out on{' '}
                                                        {visit?.present_visitation_date ? moment(visit.present_visitation_date).format("LL") : 'N/A'}.
                                                    </p>
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colSpan="3">
                                                    <h3><strong>2.0. THE PURPOSE OF FOLLOW UP VISIT AND THIS REPORT</strong></h3>
                                                    <p>
                                                        {visit?.school_name || 'The school'} was supervised by a team of{' '}
                                                        {fourthInspector?.full_name ? '4' : thirdInspector?.full_name ? '3' : '2'} officers 
                                                        led by {getInspectorName(firstInspector)}. The purpose of this follow up and support visit was to check 
                                                        whether the school fulfilled the action points that the external evaluators made during the inspection visit.
                                                        This will guide the school to improve its practice and provisions. As a result, students' learning will improve 
                                                        and they will achieve better outcomes for their own benefit and for the benefit of the nation.
                                                    </p>
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colSpan="3">
                                                    <h3><strong>3.0. FOLLOW UP INSPECTION FINDINGS</strong></h3>
                                                    <p>
                                                        The section summarises the conclusions on progress made on the action points followed by a discussion 
                                                        of the results of the findings. The results of teams' conclusions on progress on the key action points 
                                                        during the follow-up and support visit have been summarised in Table 3.1.
                                                    </p>
                                                    
                                                    <table className='table table-bordered table-responsive'>
                                                        <thead>
                                                            <tr>
                                                                <th>NES</th>
                                                                <th>Minor Recommendation</th>
                                                                <th>Comments</th>
                                                                <th>Achieved</th>
                                                                <th>Partially Achieved</th>
                                                                <th>Not Achieved</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.isArray(minorRecommendations) && minorRecommendations.length > 0 ? (
                                                                minorRecommendations.map((rec, index) => {
                                                                    const status = getAchievementStatus(rec.need_extra_followups);
                                                                    return (
                                                                        <tr key={rec.recommendation_id || index}>
                                                                            <td>{getNationalStandardName(rec.nes_id)}</td>
                                                                            <td>{rec.recommendation_description || 'N/A'}</td>
                                                                            <td>{rec.follow_up_comments || ''}</td>
                                                                            <td className="text-center">{status === 'Achieved' ? '✓' : ''}</td>
                                                                            <td className="text-center">{status === 'Partially Achieved' ? '✓' : ''}</td>
                                                                            <td className="text-center">{status === 'Not Achieved' ? '✓' : ''}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="6" className="text-center">
                                                                        No minor recommendations found for this inspection.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colSpan="3">
                                                    <h3><strong>4.0. OTHER ACTIONS POINTS DISCUSSED DURING THE FOLLOW UP INSPECTION VISIT</strong></h3>
                                                    <ul>
                                                        {Array.isArray(minorRecommendations) && minorRecommendations.length > 0 && minorRecommendations[0]?.extra_comments ? (
                                                            <li>{minorRecommendations[0].extra_comments}</li>
                                                        ) : (
                                                            <li>No additional comments recorded.</li>
                                                        )}
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        </div>
    )
}

export default ExecutiveSummaryReport